import { client } from '@generated/rfid-invite/client.gen';
import { config } from '@config';

export function getRfidInviteUrl(): string {
    return `${config.coreServicesUrl}/portal-api`;
}
client.setConfig({
    baseUrl: getRfidInviteUrl(),
});

export { client as rfidInviteClient };
